
export const supportsCaptureAttribute = () => {
  if (typeof document === "undefined") return false;
  return "capture" in document.createElement("input");
};

export const hasTouchScreen = () => {
  if (typeof navigator === "undefined") return false;
  if (typeof navigator.maxTouchPoints === "number" && navigator.maxTouchPoints > 0) return true;
  return typeof window !== "undefined" && "ontouchstart" in window;
};

export const hasCoarsePointer = () => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia("(any-pointer: coarse)").matches;
};

export const canCapturePhoto = () =>
  supportsCaptureAttribute() && (hasTouchScreen() || hasCoarsePointer());

export default canCapturePhoto;
